import React from "react";
import { FaArrowRight, FaShieldAlt, FaTimes } from "react-icons/fa";
import { trackCrossUniverseEvent } from "../lib/crossUniverseLinks";

type Props = {
  open: boolean;
  onClose: () => void;
  href: string;
  title?: string;
  description?: string;
  source?: string;
  target?: string;
  confirmLabel?: string;
};

export default function ExternalSiteTransitionModal({
  open,
  onClose,
  href,
  title = "Vous quittez Forfeo Explore",
  description = "Vous serez redirigé vers Forfeo.com, l’univers transactionnel officiel pour l’achat, la carte Accès Privilège Forfeo et les paiements sécurisés.",
  source = "unknown",
  target = "checkout",
  confirmLabel = "Continuer vers Forfeo.com",
}: Props) {
  if (!open) return null;

  const handleContinue = async () => {
    await trackCrossUniverseEvent({
      sourceSite: "forfeo_explore",
      targetSite: "forfeo_com",
      source: source as any,
      target: target as any,
      url: href,
      label: confirmLabel,
    });
    window.location.href = href;
  };

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-slate-950/70 px-4 backdrop-blur-md">
      <div className="w-full max-w-lg overflow-hidden rounded-[2rem] border border-white/20 bg-white shadow-2xl">
        <div className="bg-gradient-to-br from-slate-950 via-blue-950 to-indigo-900 p-6 text-white">
          <div className="mb-4 flex items-center justify-between">
            <div className="inline-flex items-center gap-2 rounded-full bg-white/10 px-3 py-2 text-xs font-black uppercase tracking-[0.24em] text-blue-100">
              <FaShieldAlt /> Redirection sécurisée
            </div>
            <button
              onClick={onClose}
              className="rounded-full bg-white/10 p-2 text-white transition hover:bg-white/20"
              aria-label="Fermer"
            >
              <FaTimes />
            </button>
          </div>

          <h2 className="text-2xl font-black tracking-tight">{title}</h2>
          <p className="mt-3 text-sm leading-6 text-blue-100">{description}</p>
        </div>

        <div className="space-y-4 p-6">
          <div className="rounded-2xl border border-blue-100 bg-blue-50 p-4 text-sm leading-6 text-slate-700">
            <strong className="text-slate-950">Pourquoi?</strong> Forfeo Explore sert à découvrir les
            expériences, régions, combos et idées cadeaux. Forfeo.com gère l’achat officiel, le paiement,
            les reçus et les cartes.
          </div>

          <div className="flex flex-col gap-3 sm:flex-row">
            <button
              onClick={onClose}
              className="flex-1 rounded-2xl border border-slate-200 px-5 py-3 font-bold text-slate-700 transition hover:bg-slate-50"
            >
              Rester sur Explore
            </button>
            <button
              onClick={handleContinue}
              className="flex flex-1 items-center justify-center gap-2 rounded-2xl bg-gradient-to-r from-blue-600 to-indigo-600 px-5 py-3 font-black text-white shadow-lg shadow-blue-600/20 transition hover:-translate-y-0.5"
            >
              {confirmLabel} <FaArrowRight />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
